<template>
   <OrganizationSwitcher
      :hide-personal="true"
      after-select-organization-url="/orgs/setup"
      create-organization-url="/onboarding/create-org"
      create-organization-mode="navigation"
   />
</template>
<script setup lang="ts">
import { OrganizationSwitcher } from "@clerk/vue"
import { onMounted } from "vue"
import { hasStripePriceId } from "@/services/clerk"

onMounted(async () => {
   const showCreateButton = await hasStripePriceId()
   if (!showCreateButton) {
      // Hide the create org button if user doesn't have a price ID
      const style = document.createElement("style")
      style.textContent =
         ".cl-organizationSwitcherPopoverActionButton__createOrganization { display: none !important; }"
      document.head.appendChild(style)
   }
})
</script>
<style lang="scss">
.cl-orgSwitcher-root {
   display: flex;
   justify-content: center;
   align-items: center;
}
</style>
